import { produce } from 'immer'
import {
  GET_ORGANIZATION_MEMBERS_FAILURE,
  GET_ORGANIZATION_MEMBERS_INIT,
  GET_ORGANIZATION_MEMBERS_SUCCESS,
  GetPeopleMembersActions,
} from 'src/app/PeopleMembers/redux/peopleMembers.actions'
import {
  initialState as initialPeopleMembersState,
  PeopleMembersState,
} from 'src/app/PeopleMembers/redux/peopleMembers.reducer'
import { businessRulesRouteProps } from 'src/navigation/routeProps'
import { GetOrganizationsActions } from 'src/redux/actions/data/organizations.actions'
import { createBackgroundReducer } from 'src/redux/genericReducers'

export interface BusinessRulesState {
  isCardApprovalsBeingEdited: boolean
  fetchSuccess: boolean
  fetchFailure: boolean
  puttingOrganizations: boolean
  orgMembers: PeopleMembersState
  topLevelOrganizationApproverError?: string
  patchingOrganizationApprover: boolean
  isOutOfPocketExpensesBeingEdited: boolean
}

export const initialState: BusinessRulesState = {
  isCardApprovalsBeingEdited: false,
  fetchSuccess: false,
  fetchFailure: false,
  puttingOrganizations: false,
  orgMembers: initialPeopleMembersState,
  patchingOrganizationApprover: false,
  isOutOfPocketExpensesBeingEdited: false,
}

export type Actions = GetOrganizationsActions | GetPeopleMembersActions

const CoreBusinessRulesReducer = (
  state = initialState,
  action: Actions,
): BusinessRulesState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_ORGANIZATION_MEMBERS_INIT: {
        draft.orgMembers.loading = true
        return draft
      }

      case GET_ORGANIZATION_MEMBERS_SUCCESS: {
        draft.orgMembers.loading = false
        return draft
      }

      case GET_ORGANIZATION_MEMBERS_FAILURE: {
        draft.orgMembers.loading = false
        return draft
      }
    }
  })
}

const BusinessRulesReducer = createBackgroundReducer(
  businessRulesRouteProps,
  initialState,
  CoreBusinessRulesReducer,
)

export default BusinessRulesReducer
